import { memo } from "react";
import { Button, Modal, Space } from "antd";
import IntlMessages from "components/Message/IntlMessages";
import ModalTemplate1 from "../ModalTemplate/ModalTemplate1";

const ConfirmHnwSelfDeclare = ({ code, close, actions, ...modalProps }) => {
  function onAccept() {
    close();
    actions?.onAccept && actions.onAccept();
  }

  function onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  return (
    <Modal {...modalProps}>
      <ModalTemplate1
        title={<IntlMessages id="global.upload.document.affirm-wihtout-evidence.confirm-modal.header" />}
        bodyClass="pb-2"
        body={
          <>
            <p>
              <IntlMessages id="global.upload.document.affirm-wihtout-evidence.confirm-modal.message-1" />
            </p>
            <p>
              <IntlMessages id="global.upload.document.affirm-wihtout-evidence.confirm-modal.message-2" />
            </p>
          </>
        }
        footer={
          <div className="d-flex-main">
            <Space size={20}>
              <Button className="btn button-ktb-line px-4" type="primary" style={buttonWidth} onClick={onCancel}>
                <IntlMessages id="global.cancel" />
              </Button>
              <Button
                className="btn button-ktb-main btn-block px-4"
                type="primary"
                style={buttonWidth}
                onClick={onAccept}
              >
                <IntlMessages id="global.confirm" />
                <i className="feather-icon icon-chevron-right ms-1"></i>
              </Button>
            </Space>
          </div>
        }
      />
    </Modal>
  );
};

export default memo(ConfirmHnwSelfDeclare);

const buttonWidth = {
  width: 140,
};
